import Vue from 'vue';

// Vue のルートを作る処理をここに集め、Vue 3 の createApp に切り替えるときに直す場所を 1 か所にする

// el 自体をテンプレートにして、描画結果で el を置き換える
export const mountVueApp = (el, options) => {
  const instance = new Vue({ ...options, el });
  return { instance, unmount: () => instance.$destroy() };
};

// container は残して中身だけを描画結果に差し替える
export const mountVueAppInto = (container, options) => {
  const instance = new Vue(options).$mount();
  container.replaceChildren(instance.$el);
  return { instance, unmount: () => instance.$destroy() };
};
